<template>
  <CustomScrollbar height="calc(100% - 50px)" style="padding-right: 20px">
    <section>
      <div class="container">
        <div class="title-channel">
          <div class="title">
            <h3>Asigna identificadores a la secuencia</h3>

            <p>
              Recuerda que se listarán solo los identificadores de los canales de WhatsApp, SMS y
              correo electrónico. Siempre tendrás habilitado el canal de telefonía para llamadas
              salientes.
            </p>
          </div>

          <a-alert
            v-if="showWarning"
            message="¡Ups! Parece que ya tienes otro chatbot con el mismo identificador y horario seleccionados. Por favor, modifica uno de ellos para evitar cualquier interferencia."
            banner
          />

          <p>
            <selector-channels
              withoutVoice
              :value="channels_customers"
              :disabledIdentifiers="channelsCustomersDisabled"
              :disabled="disabled"
              :channel="selectedChannel"
              :portfolioId="portfolioId"
              @update:value="channels_customers = $event"
              showAll
              toSequence
            />
          </p>
        </div>
        <div style="margin-top: auto">
          <a-alert
            message="Recuerda que si no seleccionas identificadores y decides omitir este paso, solo podrás utilizar el nodo del canal de llamadas. 
    No tendrás acceso a los nodos de SMS, WhatsApp y Email."
            type="warning"
            show-icon
          />
        </div>
      </div>
    </section>
  </CustomScrollbar>
</template>

<script>
import { defineComponent, ref, toRaw, inject, watch, computed } from "vue";

import { ChannelType } from "@/app/shared/utils/enums";

import SelectorChannels from "@/app/shared/components/selectors/SelectorChannels.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

export default defineComponent({
  components: { SelectorChannels, CustomScrollbar },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedChannel: Number,
    showWarning: Boolean,
    portfolioId: Number,
  },
  setup(_, { expose, emit }) {
    const sequenceDetails = inject("sequenceDetails");
    const channels_customers = ref(
      sequenceDetails?.value?.channels_customers?.map((channel) => channel.id) || []
    );

    const channelsCustomersDisabled = computed(
      () =>
        sequenceDetails?.value?.channels_customers?.filter((el) => el.has_nodes)?.map((channel) => channel.id) || []
    );

    const handleOk = (current) => {
      return current + 1;
    };

    const getFormState = () => ({
      channels_customers: toRaw(channels_customers.value),
    });

    watch(channels_customers, () => emit("activate-button"), { deep: false });

    const validateToggleButton = () => {
      if (channels_customers.value.some(channel => !channel)) {
        emit("toggleButton", true);
      } else {
        emit("toggleButton", false);
      }
    };

    watch(channels_customers, () =>  {
      validateToggleButton();
    }, { deep: true, immediate: true });

    expose({
      formState: {
        channels_customers: toRaw(channels_customers.value),
      },
      handleOk,
      getFormState,
      validateToggleButton,
    });
    
    return {
      channels_customers,
      ChannelType,
      sequenceDetails,
      channelsCustomersDisabled,
      validateToggleButton,
    };
  },
  watch: {},
  methods: {
    handleReset() {
      this.channels_customers = [];
    },
  },
});
</script>

<style lang="sass" scoped>
// .title-channel
.italic-style
  font-style: italic
  text-align: justify

.title
  text-align: center

  h3
    color: $gray-9
    margin-bottom: 12px
    font-size: 24px
    font-weight: 600

  p
    color: $gray-8
    font-size: 16px
    margin-bottom: 24px

.container
  display: flex
  flex-direction: column
  height: calc(100vh - 390px)
</style>
